import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createSlots as _createSlots } from "vue";
const _hoisted_1 = {
  class: "list"
};
import router from '@/router';
import { useStore } from '@/stores/pinia';
import Step1Content from './Step1Content.vue';
import { Toast } from 'vant';
import { ApiPostRecord } from '@/services/user';
export default /*#__PURE__*/_defineComponent({
  __name: 'Step1',
  setup(__props) {
    const store = useStore();
    const clickNj = () => {
      router.push(`/form/nianjing`);
    };
    const clickPw = () => {
      router.push(`/form/powa`);
    };
    const clickWg = () => {
      router.push(`/form/wugong`);
    };
    const clickSubmit = async () => {
      if (store.getBalance() <= 0) {
        Toast.fail('总金额不能小于0');
      }
      const {
        nj,
        pw,
        wg,
        formId,
        payMethod
      } = store;
      let record = {
        id: formId,
        method: Number(payMethod)
      };
      if (nj.checkList.length > 0 && Number(nj.amount) > 0 && Number(nj.repeat) > 0) {
        record.nj_list = nj.checkList.map(v => v.text);
        record.nj_amount = nj.amount;
        record.nj_repeat = nj.repeat;
      }
      if (pw.soul && Number(pw.amount) > 0 && Number(pw.repeat) > 0) {
        record.pw_soul = pw.soul;
        record.pw_amount = pw.amount;
        record.pw_repeat = pw.repeat;
      }
      if (wg.backObjectList.length > 0 && Number(wg.amount) > 0 && Number(wg.repeat) > 0) {
        record.wg_use = wg.use;
        record.wg_back = wg.backObjectList.map(v => v.name);
        record.wg_amount = wg.amount;
      }
      const loading = Toast.loading({
        message: '提交中...',
        forbidClick: true
      });
      const id = await ApiPostRecord(record);
      loading.clear();
      if (typeof id === 'string') {
        store.formId = id;
        Toast.success('提交成功');
        store.active++;
      } else {
        console.log(id);
        Toast.fail('提交失败');
      }
    };
    return (_ctx, _cache) => {
      const _component_van_radio = _resolveComponent("van-radio");
      const _component_van_radio_group = _resolveComponent("van-radio-group");
      const _component_van_cell = _resolveComponent("van-cell");
      const _component_van_cell_group = _resolveComponent("van-cell-group");
      const _component_van_icon = _resolveComponent("van-icon");
      const _component_van_action_bar_button = _resolveComponent("van-action-bar-button");
      const _component_van_action_bar = _resolveComponent("van-action-bar");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_cell_group, {
        inset: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_van_cell, {
          title: "支付方式"
        }, {
          default: _withCtx(() => [_createVNode(_component_van_radio_group, {
            modelValue: _unref(store).payMethod,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(store).payMethod = $event),
            direction: "horizontal"
          }, {
            default: _withCtx(() => [_createVNode(_component_van_radio, {
              name: "1"
            }, {
              default: _withCtx(() => [_createTextVNode("微信")]),
              _: 1
            }), _createVNode(_component_van_radio, {
              name: "2"
            }, {
              default: _withCtx(() => [_createTextVNode("支付宝")]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_van_cell_group, {
        inset: "",
        class: "mt-2"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_cell, {
          title: "念经"
        }, _createSlots({
          value: _withCtx(() => [_unref(store).nj.isFinished ? (_openBlock(), _createBlock(Step1Content, {
            key: 0,
            title: "点击编辑念经内容",
            data: {
              每天金额: _unref(store).nj.amount + ' 元',
              重复天数: _unref(store).nj.repeat + ' 天',
              合计金额: Number((Number(_unref(store).nj.amount) * Number(_unref(store).nj.repeat)).toFixed(1)) + ' 元'
            }
          }, null, 8, ["data"])) : (_openBlock(), _createElementBlock("div", {
            key: 1,
            onClick: clickNj
          }, "点击添加念经内容"))]),
          "right-icon": _withCtx(() => [_createVNode(_component_van_icon, {
            onClick: clickNj,
            name: _unref(store).nj.isFinished ? 'records' : 'add-o',
            class: "transform translate-y-1 ml-2"
          }, null, 8, ["name"])]),
          _: 2
        }, [_unref(store).nj.isFinished ? {
          name: "label",
          fn: _withCtx(() => [_createVNode(Step1Content, {
            data: {
              经咒内容: _unref(store).nj.checkList.map(v => v.text).join('、'),
              回向内容: _unref(store).nj.backContent
            }
          }, null, 8, ["data"])]),
          key: "0"
        } : undefined]), 1024)]),
        _: 1
      }), _createVNode(_component_van_cell_group, {
        inset: "",
        class: "mt-2"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_cell, {
          title: "破瓦",
          value: _unref(store).nj.isFinished ? `编辑添加破瓦内容` : `点击添加破瓦内容`
        }, _createSlots({
          value: _withCtx(() => [_unref(store).pw.isFinished ? (_openBlock(), _createBlock(Step1Content, {
            key: 0,
            title: "点击编辑破瓦内容",
            data: {
              每天金额: _unref(store).pw.amount + ' 元',
              重复天数: _unref(store).pw.repeat + ' 天',
              合计金额: Number((Number(_unref(store).pw.amount) * Number(_unref(store).pw.repeat)).toFixed(1)) + ' 元'
            },
            "click-title": clickPw
          }, null, 8, ["data"])) : (_openBlock(), _createElementBlock("div", {
            key: 1,
            onClick: clickPw
          }, "点击添加破瓦内容"))]),
          "right-icon": _withCtx(() => [_createVNode(_component_van_icon, {
            name: _unref(store).pw.isFinished ? 'records' : 'add-o',
            class: "transform translate-y-1 ml-2",
            onClick: clickPw
          }, null, 8, ["name"])]),
          _: 2
        }, [_unref(store).pw.isFinished ? {
          name: "label",
          fn: _withCtx(() => [_createVNode(Step1Content, {
            data: {
              超度对象: _unref(store).pw.soul
            }
          }, null, 8, ["data"])]),
          key: "0"
        } : undefined]), 1032, ["value"])]),
        _: 1
      }), _createVNode(_component_van_cell_group, {
        inset: "",
        class: "mt-2 mb-14"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_cell, {
          title: "五供"
        }, _createSlots({
          value: _withCtx(() => [_unref(store).wg.isFinished ? (_openBlock(), _createBlock(Step1Content, {
            key: 0,
            title: "点击编辑五供内容",
            data: {
              合计金额: Number((Number(_unref(store).wg.amount) * Number(_unref(store).wg.repeat)).toFixed(1)) + ' 元'
            },
            "click-title": clickWg
          }, null, 8, ["data"])) : (_openBlock(), _createElementBlock("div", {
            key: 1,
            onClick: clickWg
          }, "点击添加念经内容"))]),
          "right-icon": _withCtx(() => [_createVNode(_component_van_icon, {
            name: _unref(store).wg.isFinished ? 'records' : 'add-o',
            class: "transform translate-y-1 ml-2",
            onClick: clickWg
          }, null, 8, ["name"])]),
          _: 2
        }, [_unref(store).wg.isFinished ? {
          name: "label",
          fn: _withCtx(() => [_createVNode(Step1Content, {
            data: {
              用途: _unref(store).wg.use,
              回向对象: _unref(store).wg.backObjectList.map(v => v.name).join('、')
            }
          }, null, 8, ["data"])]),
          key: "0"
        } : undefined]), 1024)]),
        _: 1
      }), _createVNode(_component_van_action_bar, {
        "safe-area-inset-bottom": ""
      }, {
        default: _withCtx(() => [_createVNode(_component_van_action_bar_button, {
          disabled: "",
          color: "#be99ff",
          type: "warning",
          text: `总金额¥${_unref(store).getBalance()}`
        }, null, 8, ["text"]), _createVNode(_component_van_action_bar_button, {
          type: "danger",
          onClick: clickSubmit,
          disabled: _unref(store).getBalance() <= 0,
          text: "提交"
        }, null, 8, ["disabled"])]),
        _: 1
      })]);
    };
  }
});